import { Box, CheckBox, DateInput, Grid, MaskedInput, Text, TextInput } from "grommet";
import * as React from "react";
import { CreateMatchRequest, MatchViewModel } from "./MatchesStore";

import { format, formatISO, parseJSON, setHours, setMinutes } from "date-fns";
import { format as formatTZ, zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { DateTimePicker } from "../components/DateTimePicker";
import ThemeBuilder from "../components/ThemeBuilder";
import MatchLogoPicker from "./MatchLogoPicker";
import MatchSplashPicker from "./MatchSplashPicker";
import { useUser } from "../account/AccountStore";

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

const MatchDetails = ({ match, isBusy, onChange }: { match: MatchViewModel; isBusy: boolean; onChange: Function }) => {
    let [startDate, setStartDate] = React.useState(match.startDate);

    const [isPublic, setIsPublic] = React.useState(match.isPublic || false);
    const [archived, setArchived] = React.useState(match.archived || false);

    const [logoUri, setLogoUri] = React.useState(match.logoUri || "");
    const [splashUri, setSplashUri] = React.useState(match.splashUri || "");

    const [color, setColor] = React.useState(match.color || "");

    const [logoContent, setLogoContent] = React.useState("");
    const [splashContent, setSplashContent] = React.useState("");

    React.useEffect(() => {
        onChange({ startDate, isPublic, logoUri, logoContent, splashContent, splashUri, color, archived });
    }, [startDate, isPublic, logoUri, logoContent, splashContent, splashUri, color, archived]);

    React.useEffect(() => {
        if (match.logoUri && logoUri != match.logoUri) {
            setLogoUri(match.logoUri);
        }
        if (match.splashUri && splashUri != match.splashUri) {
            setSplashUri(match.splashUri);
        }
    }, [match.logoUri, match.splashUri]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    const handleSplashChange = ({ uri, content }) => {
        if (uri == "" && content == "") {
            setSplashUri("");
            setSplashContent("");
        }

        if (content) {
            setSplashContent(content);
            setSplashUri("");
        } else if (uri) {
            setSplashUri(uri);
            setSplashContent("");
        }
    };

    return (
        <Box width={{ max: "400px" }}>
            <Grid columns={["auto"]} gap="small">
                <DateTimePicker step={300} value={match.startDate} disabled={isBusy} onChange={setStartDate}></DateTimePicker>
                <CheckBox label="Public" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />

                <Box fill={true}>
                    <MatchLogoPicker uri={logoUri} disabled={isBusy} onSelect={handleLogoChange}></MatchLogoPicker>
                </Box>
                <Box fill={true}>
                    <MatchSplashPicker uri={splashUri} disabled={isBusy} onSelect={handleSplashChange}></MatchSplashPicker>
                </Box>
            </Grid>
            <ThemeBuilder uri={logoUri || logoContent} disabled={isBusy} color={color} onSelect={(color) => setColor(color)}></ThemeBuilder>
        </Box>
    );
};

export default MatchDetails;
